import { Link, useNavigate } from "react-router-dom";
import { Facebook, Twitter, Instagram, Linkedin } from "../../components/SvgCollection";

export default function AuthFooter() {
  const nav = useNavigate()
  return (
    <footer className="pb-3 dark:bg-themeBlack bg-themeWhite/10 backdrop-blur-md backdrop-saturate-150 ">
      <div className="relative container px-4">
        <div className="w-full text-[14px] pt-3 flex flex-wrap gap-4 items-center xs:justify-center justify-between dark:text-gray-300">
          <div>
            Copyright ©{" "}
            <span className="bg-gradient-to-r from-[#237249] to-[#35C66B] bg-clip-text text-transparent cursor-pointer" onClick={()=>nav('/')}>
              Crymadx
            </span>{" "}
            All rights reserved{" "}
          </div>
          <div className="flex gap-4 pt-2 items-center">
          <Link to="https://www.facebook.com/" target="_blank">
                  <Facebook />
                </Link>
                {/* <Link
                  to="https://x.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Twitter />
                </Link> */}

                <Link to="https://www.instagram.com/accounts/login/?hl=en" target="_blank">
                  <Instagram />
                </Link>
                <Link to="https://in.linkedin.com/" target="_blank">
                  <Linkedin />
                </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
